<template>
    <div>
        <label class="">{{label}}</label>
        <div class="custom-file-selector col-12 max-w-300px min-w-200px">
            <div class="file-field d-flex flex-wrap" style="height: 100px;border: 1px dashed;">
                <div class="d-flex justify-content-center align-items-center p-10px text-center" style="width: 100%;height: 100%;">
                    <div class="file-name-preview d-flex justify-content-center align-items-center" :data-placeholder="placeholder" style="width: 100%;">{{fileName ? fileName : ''}}</div>
                    <input
                        type="hidden"
                        :name="attrName+'_name'"
                        :value="fileName"
                    >
                </div>
                <input
                    v-if="fileView"
                    type="file"
                    class=""
                    :name="attrName"
                    v-bind:accept="attrAccept ? attrAccept : false"
                    v-bind:data-rule-accept="attrAccept ? 'false' : false"
                    v-on:change.stop="onFileSelect($event)"
                >
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CustomFileSelector",
        props:{
            label:{
                type: String,
                default: 'ファイルの選択'
            },
            attrName:{
                type: String,
                default: 'attached_file'
            },
            attrAccept:{
                type: String,
            },
            placeholder:{
                type: String,
                default: 'ファイルを選択してください'
            },
            data: {
                type: [Object, String],
                default: () => ({
                    fileName: '',
                })
            },
        },
        data() {
            return {
                fileName: this.data.fileName || '',
                fileView: true,
            }
        },
        methods: {
            log(msg,obj) {
                console.log(msg,obj);
            },
            onFileSelect(event){
                var target = event.currentTarget;
                var file = target.files[0];
                if(file != null){
                    this.fileName = file.name;
                }else{
                    this.fileName = null;
                }
            },
            reset () {
                this.fileView = false;
                this.fileName = null;
                this.$nextTick(function () {
                    this.fileView = true
                })
            }
        }
    }
</script>

<style scoped>

</style>

<style lang="scss">

    div.custom-file-selector {
        div.file-name-preview{
            &:empty{
                border-bottom: 2px solid #FF0000;
                &:not(:focus)::before{
                    content: attr(data-placeholder);
                    background: url("data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20height%3D%2215%22%20viewBox%3D%220%200%20640%20512%22%3E%3Cpath%20fill%3D%22%23707070%22%20d%3D%22M537.6%20226.6c4.1-10.7%206.4-22.4%206.4-34.6%200-53-43-96-96-96-19.7%200-38.1%206-53.3%2016.2C367%2064.2%20315.3%2032%20256%2032c-88.4%200-160%2071.6-160%20160%200%202.7.1%205.4.2%208.1C40.2%20219.8%200%20273.2%200%20336c0%2079.5%2064.5%20144%20144%20144h368c70.7%200%20128-57.3%20128-128%200-61.9-44-113.6-102.4-125.4zM393.4%20288H328v112c0%208.8-7.2%2016-16%2016h-48c-8.8%200-16-7.2-16-16V288h-65.4c-14.3%200-21.4-17.2-11.3-27.3l105.4-105.4c6.2-6.2%2016.4-6.2%2022.6%200l105.4%20105.4c10.1%2010.1%202.9%2027.3-11.3%2027.3z%22%2F%3E%3C%2Fsvg%3E") no-repeat;
                    background-size: 20px 17px;
                    padding-left: 25px;
                    background-position-x: left;
                    background-position-y: top;
                }
            }
            &:not(:empty){
                border-bottom: 2px solid #00FF00;
            }
        }
        >.file-field:hover{
            outline: 0;
            -webkit-box-shadow: 0 5px 11px 0 rgba(0,0,0,0.18), 0 4px 15px 0 rgba(0,0,0,0.15);
            box-shadow: 0 5px 11px 0 rgba(0,0,0,0.18), 0 4px 15px 0 rgba(0,0,0,0.15);
        }
    }
</style>